export default {
  menu: 1000,
  appBar: 1100,
  leftNavOverlay: 1200,
  leftNav: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  tooltip: 3000,
};



/** WEBPACK FOOTER **
 ** ../src/styles/zIndex.js
 **/